import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import { SpeakersList } from '../../../data/speakersList';
import { Speaker } from './Speaker';
import { KeynoteList } from '../../../data/KeynotesList';
import PropTypes from 'prop-types';
import { useState } from 'react';

export const SpeakerModal = ({ speaker, closeModal }) => {
  return (
    <>
      {speaker ? (
        <div className="snn-speaker-modal">
          <div className="snn-speaker-modal-top-bar">
            <span onClick={closeModal} className="snn-user-menu-icon material-symbols-outlined">
              close
            </span>
          </div>
          <div className="snn-speaker-modal-content">
            <div className="snn-speaker-modal-content-img-wrapper">
              <img src={speaker.img} alt={speaker.alt} />
            </div>
            <div className="snn-speaker-modal-content-main">
              <h2>{speaker.name}</h2>
              <p className="snn-speaker-modal-affiliation">{speaker.affiliation}</p>
              <p className="snn-speaker-resume">{speaker.resume}</p>
              {speaker.abstract ? (
                <>
                  <hr />
                  <h2>{speaker.title}</h2>
                  <div dangerouslySetInnerHTML={{ __html: speaker.abstract }} />
                </>
              ) : null}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export const SpeakersWrapper = () => {
  const [selectedSpeaker, setSelectedSpeaker] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const selectSpeaker = (speakerId, list) => {
    console.log(speakerId, list);
    const speaker = list.find((speaker) => speaker.id === speakerId);
    setSelectedSpeaker(speaker);
    setIsModalOpen(true);
  };

  return (
    <>
      <TopBar options={PublicOptions} />
      <div className={isModalOpen ? '' : 'hide'}>
        <SpeakerModal speaker={selectedSpeaker} closeModal={closeModal} />
      </div>
      <div className="content">
        <section className="snn-page-section">
          <h2 className="snn-title">Plenaristas</h2>
          <div className="snn-keynotes-cards-wrapper">
            {KeynoteList.map((speaker) => (
                <Speaker
                    speaker={speaker}
                    key={speaker.id}
                    handleClick={() => selectSpeaker(speaker.id, KeynoteList)}
                />
            ))}
          </div>
          <h2 className="snn-title">Pláticas invitadas</h2>
          <div className="snn-speakers-cards-wrapper">
            {SpeakersList.map((speaker) => (
                <Speaker
                    speaker={speaker}
                    key={speaker.id}
                    handleClick={() => selectSpeaker(speaker.id, SpeakersList)}
                />
            ))}
          </div>
        </section>
      </div>
      <Footer/>
    </>
  );
};

SpeakerModal.propTypes = {
  speaker: PropTypes.any.isRequired,
  closeModal: PropTypes.func,
};
